import React from 'react';
import { ControlIcons } from '@/Static/IconsRes';
import { Icon } from '@/Components/Icon/Icon';
import Button from 'devextreme-react/button';
import styles from './TableSearchButton.scss';

type Props = {
  onClick: () => void;
};

export const TableSearchButton = ({ onClick }: Props): React.ReactElement => {
  return (
    <Button onClick={onClick}>
      <Icon alt="showTableSearch" src={ControlIcons.TableSearch} className={styles.icon} />
    </Button>
  );
};
